/**
 * Fiskal Cloud Notification API
 * # Changelog ## 1.0.0 * Initial Admin API 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailNotificationTypeDTO } from './email-notification-type-dto';
import { EmailNotificationLanguageDTO } from './email-notification-language-dto';


/**
 * EmailNotification
 */
export interface EmailNotificationBodyDTO { 
    type: EmailNotificationTypeDTO;
    to?: Array<string>;
    cc?: Array<string>;
    /**
     * Map of properties used for notification
     */
    properties?: { [key: string]: any; };
    language: EmailNotificationLanguageDTO;
    /**
     * Flag indicationg whether notification should be persisted
     */
    persistent?: boolean;
    /**
     * Optional theme selector
     */
    theme?: string;
}

export class ClsEmailNotificationBodyDTO { 
    type: EmailNotificationTypeDTO = undefined;
    to?: Array<string> = undefined;
    cc?: Array<string> = undefined;
    /**
     * Map of properties used for notification
     */
    properties?: { [key: string]: any; } = undefined;
    language: EmailNotificationLanguageDTO = undefined;
    /**
     * Flag indicationg whether notification should be persisted
     */
    persistent?: boolean = undefined;
    /**
     * Optional theme selector
     */
    theme?: string = undefined;
}



